import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import SEO from "../components/SEO";

export default function AboutUs() {
  return (
    <>
      <SEO
        title="About Us - Online Tools Center"
        description="Learn more about Online Tools Center and our mission to provide free online tools for everyone."
        keywords="about online tools center, free online tools, utility tools, finance tools"
        url="https://online-tools-center.vercel.app/about-us"
      />

      <Navbar />

      {/* HERO */}

      <section
        style={{
          background:
            "linear-gradient(135deg,#0f172a,#1e293b)",
          color: "white",
          padding:
            "80px 20px",
        }}
      >

        <div className="container text-center">

          <span className="badge bg-primary p-2 mb-3">
            About Our Platform
          </span>

          <h1
            className="fw-bold mb-4"
            style={{
              fontSize:
                "clamp(2.5rem,5vw,4rem)",
            }}
          >
            About Online Tools Center
          </h1>

          <p
            className="lead mx-auto"
            style={{
              maxWidth: "850px",
            }}
          >
            We build fast, secure,
            and free online tools
            for students,
            developers,
            businesses,
            and everyday users.
          </p>

        </div>

      </section>

      {/* MAIN CONTENT */}

      <div className="container py-5">

        <div className="row g-4">

          <div className="col-lg-8">

            <div className="card border-0 shadow-lg rounded-4 p-4 p-md-5">

             <h2 className="fw-bold mb-4">Our Mission</h2>
              <p className="text-muted">
                Online Tools Center was built with one simple goal: to give
                everyone access to powerful, reliable tools without paying a
                subscription, creating an account, or installing software. We
                believe that everyday tasks like calculating a loan EMI, merging
                PDF files, generating a QR code, or checking your income tax
                should take seconds — not require a trip to a professional or
                hours of research.
              </p>
              <p className="text-muted">
                Our platform is designed for students who need quick
                calculations, professionals who handle documents daily,
                developers who need to validate or decode data, and anyone who
                wants a faster way to get things done online. Every tool on
                this platform runs entirely in your browser, which means your
                data is never uploaded to any server and your privacy is always
                protected.
              </p>

              <h2 className="fw-bold mt-5 mb-4">What We Offer</h2>
              <p className="text-muted">
                Online Tools Center is organized into five main categories,
                each designed to serve a specific set of user needs.
              </p>

              <div className="row g-4">
                <div className="col-md-6">
                  <div className="card h-100 border-0 bg-light rounded-4">
                    <div className="card-body">
                      <h5 className="fw-bold">Finance Tools</h5>
                      <p className="text-muted mb-0">
                        Our finance calculators help you make smarter money
                        decisions. Calculate your home, car, or personal loan
                        EMI with a full amortization schedule, compare the old
                        vs new income tax regime, check loan eligibility, and
                        compute percentages instantly.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="card h-100 border-0 bg-light rounded-4">
                    <div className="card-body">
                      <h5 className="fw-bold">PDF Tools</h5>
                      <p className="text-muted mb-0">
                        Handle PDF documents without installing any software.
                        Merge multiple PDF files into one, split a PDF into
                        individual pages, or convert JPG and PNG images into
                        a professional PDF document — all directly in your
                        browser.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="card h-100 border-0 bg-light rounded-4">
                    <div className="card-body">
                      <h5 className="fw-bold">Developer Tools</h5>
                      <p className="text-muted mb-0">
                        Save time on repetitive development tasks. Format and
                        validate JSON with syntax highlighting, decode JWT
                        tokens to inspect headers and payloads, and more tools
                        designed for developers who need quick, reliable
                        utilities without opening a full IDE.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="card h-100 border-0 bg-light rounded-4">
                    <div className="card-body">
                      <h5 className="fw-bold">Utility Tools</h5>
                      <p className="text-muted mb-0">
                        Everyday tools that just work. Generate strong random
                        passwords, create QR codes for any URL or text, count
                        words and characters in your writing, calculate your
                        exact age, or use a professional stopwatch with lap
                        timing — all free and instant.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="card h-100 border-0 bg-light rounded-4">
                    <div className="card-body">
                      <h5 className="fw-bold">Health Tools</h5>
                      <p className="text-muted mb-0">
                        Quickly check your Body Mass Index using our BMI
                        calculator. Enter your height and weight to instantly
                        see your BMI value and which weight category you fall
                        into, with guidance on what the result means for your
                        health.
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <h2 className="fw-bold mt-5 mb-4">Our Commitment to Privacy</h2>
              <p className="text-muted">
                Privacy is not an afterthought for us — it is a core design
                principle. The vast majority of tools on Online Tools Center
                process all data locally inside your web browser using
                JavaScript. This means when you paste text into the Word
                Counter, upload files to the PDF Merger, or enter financial
                figures into the EMI Calculator, that information never leaves
                your device. No data is stored on our servers. No accounts are
                created. No personal information is collected beyond standard
                anonymous analytics used to understand which tools people find
                most useful.
              </p>

              <h2 className="fw-bold mt-5 mb-4">Why Users Choose Us</h2>
              <p className="text-muted">
                There are many online tool platforms available, but most either
                require signup, limit usage, push you toward paid plans, or are
                cluttered with ads and pop-ups. Online Tools Center is different.
                Every single tool is available immediately with no friction — no
                login screen, no trial period, no watermark on outputs. The
                interface is clean and mobile-friendly so it works equally well
                on a smartphone, tablet, or desktop computer. Tools load quickly
                because they run in your browser rather than relying on slow
                server processing. And the platform is continuously updated with
                new tools based on what users actually need.
              </p>

              <h2 className="fw-bold mt-5 mb-4">Contact Us</h2>
              <p className="text-muted">
                We are always happy to hear from users. Whether you have a
                suggestion for a new tool, found a bug, or just want to share
                feedback, please reach out to us at{" "}
                <a href="mailto:emicalculator.official@gmail.com">
                  emicalculator.official@gmail.com
                </a>
                . We read every message and use your feedback to improve the
                platform.
              </p>

              <p className="text-muted">
                Online Tools Center was
                created to provide simple,
                useful, and fast browser-based
                tools that anyone can use
                for free without registration.
              </p>

              <p className="text-muted">
                Our goal is to help users
                save time using practical
                tools for finance,
                productivity,
                PDF management,
                development,
                and everyday calculations.
              </p>

              <h2 className="fw-bold mt-5 mb-4">
                What We Offer
              </h2>

              <div className="row g-4">

                <div className="col-md-6">

                  <div className="card h-100 border-0 bg-light rounded-4">

                    <div className="card-body">

                      <h5 className="fw-bold">
                        Finance Tools
                      </h5>

                      <p className="text-muted mb-0">
                        EMI calculators,
                        tax calculators,
                        percentage tools,
                        and loan eligibility tools.
                      </p>

                    </div>

                  </div>

                </div>

                <div className="col-md-6">

                  <div className="card h-100 border-0 bg-light rounded-4">

                    <div className="card-body">

                      <h5 className="fw-bold">
                        PDF Tools
                      </h5>

                      <p className="text-muted mb-0">
                        Merge PDFs,
                        split PDFs,
                        and convert images
                        into PDF documents.
                      </p>

                    </div>

                  </div>

                </div>

                <div className="col-md-6">

                  <div className="card h-100 border-0 bg-light rounded-4">

                    <div className="card-body">

                      <h5 className="fw-bold">
                        Developer Tools
                      </h5>

                      <p className="text-muted mb-0">
                        JSON formatter,
                        JWT decoder,
                        and other tools
                        for developers.
                      </p>

                    </div>

                  </div>

                </div>

                <div className="col-md-6">

                  <div className="card h-100 border-0 bg-light rounded-4">

                    <div className="card-body">

                      <h5 className="fw-bold">
                        Utility Tools
                      </h5>

                      <p className="text-muted mb-0">
                        QR generators,
                        password generators,
                        word counters,
                        and more.
                      </p>

                    </div>

                  </div>

                </div>

              </div>

              <h2 className="fw-bold mt-5 mb-4">
                Why Users Choose Us
              </h2>

              <ul className="text-muted">

                <li className="mb-3">
                  100% free online tools
                </li>

                <li className="mb-3">
                  No registration required
                </li>

                <li className="mb-3">
                  Fast and responsive design
                </li>

                <li className="mb-3">
                  Mobile-friendly interface
                </li>

                <li className="mb-3">
                  Secure browser-based processing
                </li>

                <li className="mb-3">
                  Regularly updated tools
                </li>

              </ul>

            </div>

          </div>

          {/* SIDEBAR */}

          <div className="col-lg-4">

            <div className="card border-0 shadow-lg rounded-4 p-4 mb-4">

              <h4 className="fw-bold mb-3">
                Platform Highlights
              </h4>

              <div className="mb-3">

                <h3 className="fw-bold text-primary">
                  15+
                </h3>

                <p className="text-muted mb-0">
                  Online Tools
                </p>

              </div>

              <div className="mb-3">

                <h3 className="fw-bold text-success">
                  Free
                </h3>

                <p className="text-muted mb-0">
                  No Signup Required
                </p>

              </div>

              <div>

                <h3 className="fw-bold text-danger">
                  Secure
                </h3>

                <p className="text-muted mb-0">
                  Browser-Based Processing
                </p>

              </div>

            </div>

            <div className="card border-0 shadow-lg rounded-4 p-4">

              <h4 className="fw-bold mb-3">
                Popular Tools
              </h4>

              <div className="d-grid gap-3">

                <a
                  href="/emi-calculator"
                  className="btn btn-outline-primary"
                >
                  EMI Calculator
                </a>

                <a
                  href="/tax-calculator"
                  className="btn btn-outline-primary"
                >
                  Tax Calculator
                </a>

                <a
                  href="/merge-pdf"
                  className="btn btn-outline-primary"
                >
                  Merge PDF
                </a>

                <a
                  href="/json-formatter"
                  className="btn btn-outline-primary"
                >
                  JSON Formatter
                </a>

              </div>

            </div>

          </div>

        </div>

      </div>

      {/* FAQ */}

      <section className="py-5 bg-light">

        <div className="container">

          <div className="text-center mb-5">

            <h2 className="fw-bold">
              Frequently Asked Questions
            </h2>

          </div>

          <div className="accordion" id="aboutFaq">

            <div className="accordion-item">

              <h2 className="accordion-header">

                <button
                  className="accordion-button"
                  data-bs-toggle="collapse"
                  data-bs-target="#faq1"
                >
                  Are all tools free?
                </button>

              </h2>

              <div
                id="faq1"
                className="accordion-collapse collapse show"
              >

                <div className="accordion-body">

                  Yes, all tools on our platform
                  are completely free to use.

                </div>

              </div>

            </div>

            <div className="accordion-item">

              <h2 className="accordion-header">

                <button
                  className="accordion-button collapsed"
                  data-bs-toggle="collapse"
                  data-bs-target="#faq2"
                >
                  Is registration required?
                </button>

              </h2>

              <div
                id="faq2"
                className="accordion-collapse collapse"
              >

                <div className="accordion-body">

                  No signup or registration
                  is required to use our tools.

                </div>

              </div>

            </div>

            <div className="accordion-item">

              <h2 className="accordion-header">

                <button
                  className="accordion-button collapsed"
                  data-bs-toggle="collapse"
                  data-bs-target="#faq3"
                >
                  Are files secure?
                </button>

              </h2>

              <div
                id="faq3"
                className="accordion-collapse collapse"
              >

                <div className="accordion-body">

                  Most tools process data directly
                  in your browser for better privacy.

                </div>

              </div>

            </div>

          </div>

        </div>

      </section>

      <Footer />

    </>
  );
}